import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDHeadlineText } from '@facet-wealth/design';
import {
  TaxStrategyDetailsSections,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/Sections/TaxStrategyDetailsSections';

const TaxStrategyDetailsMetaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { color: 'textSecondary', align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['subtitle'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', color: 'textSecondary', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('sections', {
    _component: () => TaxStrategyDetailsSections,
  }, overrideReadOnly);

export default TaxStrategyDetailsMetaOverride;
